/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { BasePathRequestDto, BasePathResponseDto, ErrorHttpContentDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class MetadataClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Metadata
   * @name MetadataBasePath
   * @summary Gets a BasePathResponse.
   * @request POST:/metadata/BasePath
   */
  metadataBasePath = (data: BasePathRequestDto, params: RequestParams = {}) =>
    this.http.request<BasePathResponseDto, ErrorHttpContentDto>({
      path: `/metadata/BasePath`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
